module.exports = __webpack_public_path__ + "img/icon_map_ljsh.5bad609f.png";